module.exports = "/_next/static/images/460554bd672621262af51666bd1b29e4-creditsprd-md.jpg";